import environment from "environment";
import HttpErrorResponseModel from "models/HttpErrorResponseModel";
import EffectUtility from "utilities/EffectUtility";
import PreventiviConFirmaDigitaleModel from "./models/PreventiviConFirmaDigitaleModel";
import PreventiviInScadenzaModel from "./models/PreventiviInScadenzaModel";
import AppointmentModel from "./models/AppointmentModel";

export default class NotificheEffect {
    public static async getExpiringEstimateNotification(): Promise<PreventiviInScadenzaModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.expiringEstimateNotification;
        return EffectUtility.getToModel<PreventiviInScadenzaModel>(PreventiviInScadenzaModel, endpoint);
    }

    public static async getDigitalSignedDocumentNotification(): Promise<
        PreventiviConFirmaDigitaleModel | HttpErrorResponseModel
    > {
        const endpoint: string = environment.api.digitalSignedDocumentsNotification;
        return EffectUtility.getToModel<PreventiviConFirmaDigitaleModel>(PreventiviConFirmaDigitaleModel, endpoint);
    }

    public static async getAppointmentNotification(): Promise<AppointmentModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.appointmentNotification;
        return EffectUtility.getToModel<AppointmentModel>(AppointmentModel, endpoint);
    }
}
